import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("netcrm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    if (status === 401 && !window.location.pathname.startsWith("/c/")) {
      localStorage.removeItem("netcrm_token");
      localStorage.removeItem("netcrm_user");
    }
    // Plan / quota limit hit — surface global upgrade modal
    if (status === 402) {
      const detail = err.response?.data?.detail || "You've hit your plan limit. Upgrade to continue.";
      window.dispatchEvent(new CustomEvent("nc:plan-limit", { detail: { message: detail } }));
    }
    return Promise.reject(err);
  }
);
